import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../lib/api";
import { useAuth, LOGO_URL } from "../context/AuthContext";

export default function MagicVerify() {
    const [sp] = useSearchParams();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [status, setStatus] = useState("verifying"); // verifying | error
    const [msg, setMsg] = useState("Verifying sign-in link…");
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const token = sp.get("token");
        if (!token) {
            setStatus("error");
            setMsg("Missing or invalid sign-in link.");
            return;
        }
        (async () => {
            try {
                const res = await authApi.verifyMagicLink(token);
                setUser(res.user);
                navigate("/dashboard", { replace: true });
            } catch (err) {
                setStatus("error");
                setMsg(
                    err?.response?.data?.detail ||
                        "This sign-in link is invalid or has expired.",
                );
            }
        })();
    }, [sp, navigate, setUser]);

    return (
        <div
            className="min-h-screen flex items-center justify-center px-4"
            data-testid="magic-verify-page"
        >
            <div className="w-full max-w-md">
                <div className="bg-[#E8241A] brut-border brut-shadow p-6 mb-[-20px] relative z-10">
                    <img
                        src={LOGO_URL}
                        alt="911 Cellphone Bank"
                        className="w-full h-auto"
                    />
                </div>
                <div className="bg-white brut-border brut-shadow p-8 pt-10 text-center">
                    {status === "verifying" ? (
                        <div
                            className="font-display text-2xl animate-pulse"
                            data-testid="magic-verifying"
                        >
                            {msg}
                        </div>
                    ) : (
                        <>
                            <div className="font-display text-2xl mb-3">
                                Can't sign you in.
                            </div>
                            <p className="text-sm mb-5">{msg}</p>
                            <button
                                onClick={() => navigate("/login")}
                                className="bg-black text-white font-display px-5 py-3 brut-border brut-shadow-sm brut-press"
                                data-testid="magic-back-to-login"
                            >
                                Back to sign-in
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
